export type ErrorType = {
  code: string | number;
  message: {
    title: string;
    description: string;
  };
};

export const CLEAR_REDUCERS: 'CLEAR_REDUCERS' = 'CLEAR_REDUCERS';
